import { SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from "../constants";

/**
 * Returns true if user needs to select the session to be able to go
 * @param {object} session Session to check
 * @returns boolean
 */
export function isSessionAttendanceOptional(session) {
    return session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ROUND || (session.is_selectable && !session.is_selected);
}
